export class MediaLibraryType
{
    Type:string
    Mime:string
}
export class MediaLibrarySize
{
    Mime:string
    MaxSize:number
}
export class MediaLibraryConsts {
    static AllowUploadTypes:Array<MediaLibraryType> =new Array<MediaLibraryType>();
    static MaxSizeLimitInByte :Array<MediaLibrarySize> =new Array<MediaLibrarySize>();
    static GeneralSizeLimit: number;
    static AllowUploadtypesLabel:string;
    static  SizeSuffixes :string[] =    [ "bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB" ];
    static  SizeSuffix(value:number):string
{
    if (value === 0) return 'n/a'
   let log=Math.floor(Math.log(value) / Math.log(1024));
    let i = parseInt(log.toString());
    if (i === 0) return `${value} ${this.SizeSuffixes[i]})`
    return `${(value / (1024 ** i)).toFixed(1)} ${this.SizeSuffixes[i]}`
}
static b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
static getMaxSizeByType(fileType: string) {
        let allowedfiles = this.AllowUploadTypes.filter(filetypes => { return filetypes.Type == fileType });
        let mimetype = "*";
        if (allowedfiles.length > 0) {
            mimetype = allowedfiles[0].Mime;
        }
        let filesize = 0;
        let filesizes = this.MaxSizeLimitInByte.filter(searchfilesize => { return searchfilesize.Mime == mimetype });
        if (filesizes.length == 0) {
            mimetype = mimetype.split('/')[0] + "/*";
            filesizes = this.MaxSizeLimitInByte.filter(filesize => { filesize.Mime == mimetype });
            if (filesizes.length > 0) {
                return filesizes[0].MaxSize;
            } else {
                filesizes=  this.MaxSizeLimitInByte.filter(filesize => { filesize.Mime == "*" });
               return filesizes[0].MaxSize;
            }
        }else
        {
           return filesizes[0].MaxSize;
        }
    }
}

